import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, DateQueryPicker, QueryDropdown } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function PatientListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        queryPickerStore,
        filterOnChange,
        facilityStore
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} filterVisible={true}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-3 form__group">
                            <QueryDropdown queryUtility={queryUtility} onChange={filterOnChange} isFetch={true} store={facilityStore} propertyName="facilityId" label="Facility" />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <label className="form__group__label">Date Of Birth</label>
                            <DateQueryPicker store={queryPickerStore} queryUtility={queryUtility} propertyName='dateOfBirth' />
                        </div>
                    </TableFilter>

                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='PATIENT.LIST.EMPTY_STATE.TITLE' description='PATIENT.LIST.EMPTY_STATE.DESCRIPTION' />
}

PatientListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(PatientListTemplate);
